//Core module
import React, {Fragment} from 'react';

//External module
import {Button} from "reactstrap";
import cx from "classnames";

//Internal module
import FormHeader from "../../../Common/FormHeader";
import ListTable from "../../../Common/ListTable";
import requestApi from "../../../services/requestApi.service";
import {
    convertUTCToLocalTime, currencyFormatter, handleErrorResponse, titleCase,
} from "../../../Common/Appcommon";
import CustomCharges from "./CustomCharges";


class PaymentHistory extends React.Component {

    constructor(props) {
        super(props);

        this.state={
            page:1,
            limit: 20,
            totalCount: 0,
            formData : [],
        }
    }

    componentDidMount = async () => {
        await this.loadFormData();
    };

    loadFormData = async () => {

        let params = {
            "ENTITY": "razorpay",
            "OPERATION": "GET_PAYMENTHISTORY",
            "NUMBEROFROW" : this.state.limit,
            "PAGENUMBER" : this.state.page
        };

        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data
            this.setState({
                totalCount : data[1],
                formData : data[2],
            })
        }
    }

    onPageChange = async (page) => {
        this.setState({page},async ()=>{
            await this.loadFormData();
        });
    }

    renderElements = (name,formData) => {

        if(name === 'paymentid'){

            const paymentid = formData['paymentid'];

            let createdOn = formData['createdOn'];

            if(createdOn !== "" && createdOn !== null){
                createdOn = convertUTCToLocalTime(createdOn);
            }

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={` template-primary `}>{paymentid}</span>
                        <span className={'template-secondary'}>{createdOn}</span>
                    </div>
                </>
            )
        }else if(name === 'amount'){

            let amount = formData['amount'];
            if(formData['frequency'] === "Reduce User"){
                amount = 0;
            }
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={` template-primary `}>{amount ? currencyFormatter('en-IN', 'INR', amount,0) : currencyFormatter('en-IN', 'INR', amount,0)}</span>
                    </div>
                </>
            )
        }else if(name === 'paymentstatus'){

            let paymentstatus = formData['paymentstatus'];
            let paymentid = formData['paymentid'];
            let fontClassname = '';
            if(paymentid === ""){
                paymentstatus = "failed";
            }
            if(paymentstatus == null){
                paymentstatus = `Paid`;
            }
            paymentstatus = paymentstatus.toLowerCase();
            if(paymentstatus === 'captured'){
                paymentstatus = 'paid';
            }
            if(paymentstatus === 'paid'){
                fontClassname = 'payment-success';
            } else if(paymentstatus === 'pending'){
                fontClassname = 'payment-warning';
            } else if(paymentstatus === 'created' || paymentstatus === 'authorized' || paymentstatus === 'refunded' || paymentstatus === "attempted"){
                fontClassname = 'payment-info';
            } else{
                fontClassname = 'payment-cancel';
            }
            
            paymentstatus = titleCase(paymentstatus);

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={` template-primary ${fontClassname}`}>{paymentstatus}</span>
                    </div>
                </>
            )
        }else if(name === 'Type'){
            let Paymentlabel = "Manual";
            let paymenttype = formData['subscriptionid'];
            if(paymenttype === "Emandate"){
                Paymentlabel = "Subscription";
            }
            /* if(paymenttype !== undefined && paymenttype !== null){
                paymenttype = "Subscription";
            } else{
                paymenttype = "Manual";
            } */

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={`template-primary`}>{Paymentlabel}</span>
                    </div>
                </>
            )
        }else if(name === 'Date'){

            let createdOn = formData['createdOn'];

            if(createdOn !== "" && createdOn !== null){
                createdOn = convertUTCToLocalTime(createdOn);
            }

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={`template-primary`}>{createdOn}</span>
                    </div>
                </>
            )
        } else if(name === 'Invoice'){

            if(formData['orderid'] && formData['orderid'] !== "" && formData['frequency'] !== "Reduce User"){
                let paymentstatus = formData['paymentstatus'];
                let paymentid = formData['paymentid'];

                return (
                    <div 
                        className={cx(
                            `text-left`, 
                                {
                                    "hide" : paymentstatus !== 'Paid' && 
                                    paymentstatus !== 'Cancelled' && 
                                    paymentstatus !== 'captured' && 
                                    paymentstatus !== null || 
                                    paymentid == ""
                                }
                            )
                        }
                    >
                        <Button onClick={()=>this.viewInvoice(formData)} className="m-1 me-2 btn-icon le-button lePrimaryBtn btn btn-success">
                            Download
                        </Button>
                    </div>
                )
            }
        }
    }

    viewInvoice = async (formdata) => {
        if(formdata['paymentstatus'] !== 'Paid' && formdata['paymentstatus'] !== 'Cancelled' && formdata['paymentstatus'] !== null){
            return;
        }
        if(formdata['orderid'] !== undefined &&  formdata['orderid'] !== "" && formdata['orderid'] != null){
            const params = {
                "ENTITY": "invoicegeneration",
                "OPERATION": "GETALL",
                "orderid": formdata['orderid'],
                "iswpapp" : true
            };

            let response = await requestApi.processServerRequest(params,'WebV2','post');
            if(response.issuccess){
                if(response.data && response.data !== ""){
                    this.openInNewTab(response.data);
                }
            }else{
                handleErrorResponse(response.errormsg);
            }
        }
    }

    openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    render(){

        let {limit, page, totalCount} = this.state;

        let listFields =[
            ['Payment ID', 'Amount', 'Type', 'Frequency', 'paymentstatus', 'Invoice'],
            ['paymentid', 'amount', 'Type', 'frequency', 'paymentstatus', 'Invoice']
        ];

        let headerFieldConfig = {
            "Payment ID" : {
                "class" : "text-left"
            },
            "Amount" : {
                "class" : "text-left"
            },
            "Date" : {
                "class" : "text-left"
            },
            "Type" : {
                "class" : "text-left"
            },
            "Frequency" : {
                "class" : "text-left"
            },
            "paymentstatus" : {
                "class" : "text-left"
            },
            "Invoice" : {
                "class" : "text-left"
            },
        };

        let customFieldConfig = {

            paymentid : {
                "render" : "paymentid",
                "class": "template-message text-left",
            },
            createdOn : {
                "render" : "Date",
                "class" : "text-left"
            },
            amount : {
                "render" : "amount",
                "class" : "text-left"
            },
            Type : {
                "render" : "Type",
                "class" : "text-left"
            },
            frequency : {
                "class": "text-left",
            },
            paymentstatus : {
                "render" : "paymentstatus",
            },
            Invoice : {
                "render" : "Invoice",
                "class" : "text-left"
            },

        };

        return (
            <Fragment>
                <div className="listview-container templates-listview payment-history kv-main-wrapper h100per pb-3">
                    <FormHeader
                        headerText = "Payments"
                        headerDesc = "Explore your payments: a comprehensive record of all your transactions."
                    />
                    <div className={'mb-2'}>
                        <CustomCharges />
                        <ListTable
                            key={Math.random()}
                            formData={this.state.formData}
                            fields={listFields}
                            showRowCount={true}
                            renderElements={this.renderElements}
                            headerConfig={headerFieldConfig}
                            config={customFieldConfig}
                            noDataMsg={`Templates not found`}
                            customClass={'no-border-table'}
                            prefix = {"paymenthistory"}
                            pagination={true}
                            onPageChange={this.onPageChange}
                            currentPage={page}
                            totalCount={totalCount}
                            limit={limit}
                        />
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default PaymentHistory;
